module.exports = __webpack_public_path__ + "img/Mask Group 2914@2x.71a41790.png";